import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";

import Cookies from "js-cookie";
import API from "../../../services/apiHelpers";
import VideosPreview from "./VideosPreview";
import VideosList from "./VideosList";
import Section from "../Section/Section";

function VideosSection() {
  const { i18n } = useTranslation();
  const [videos, setVideos] = useState({
    count: -1,
    next: null,
    previous: null,
    results: [],
  });

  const getVideos = next =>
    API()
      .get(next || "/api/v1/videos/", {
        params: {
          lang_code: Cookies.get("user_lang")
            ? Cookies.get("user_lang").toUpperCase()
            : i18n.language.toUpperCase(),
          ordering: "-published_at",
        },
      })
      .then(({ data }) => {
        if (next) {
          return setVideos({
            count: data.count,
            next: data.next,
            previous: data.previous,
            results: [...videos.results, ...data.results],
          });
        }
        return setVideos(data);
      });
  const { t } = useTranslation(["widgets"]);

  useEffect(() => {
    if (videos.count === -1) {
      getVideos();
    }
  }, []);

  if (videos.count <= 0) {
    return null;
  }

  const [firstVideo] = videos.results;

  return (
    <Section
      className="VideosSection"
      title={<h2>{t("widgets:videos.title")} </h2>}
    >
      <Row>
        <Col xs={12} lg={7}>
          <VideosPreview video={firstVideo} />
        </Col>
        <Col xs={12} lg={5}>
          <VideosList getVideos={getVideos} videos={videos} />
        </Col>
      </Row>
    </Section>
  );
}

export default VideosSection;
